const indexItems = [
  { title: '影视吃瓜', desc: '最新影视圈大瓜合集', icon: 'ri-movie-2-line', color: 'bg-primary-100 text-primary-600' },
  { title: '综艺吃瓜', desc: '综艺节目热点追踪', icon: 'ri-tv-2-line', color: 'bg-accent-100 text-accent-600' },
  { title: '明星动态', desc: '明星最新动向速递', icon: 'ri-star-line', color: 'bg-secondary-100 text-secondary-700' },
  { title: '恋情曝光', desc: '明星恋情大瓜第一手', icon: 'ri-heart-2-line', color: 'bg-primary-100 text-primary-500' },
  { title: '争议事件', desc: '娱乐圈争议全记录', icon: 'ri-alert-line', color: 'bg-accent-100 text-accent-700' },
  { title: '作品发布', desc: '新歌新剧新片资讯', icon: 'ri-music-2-line', color: 'bg-secondary-100 text-secondary-600' },
  { title: '行业内幕', desc: '娱乐圈深度揭秘', icon: 'ri-eye-off-line', color: 'bg-primary-100 text-primary-700' },
  { title: '粉丝热议', desc: '饭圈话题精选集', icon: 'ri-chat-1-line', color: 'bg-accent-100 text-accent-500' },
  { title: '跨界吃瓜', desc: '体育电竞圈娱乐化', icon: 'ri-global-line', color: 'bg-secondary-100 text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            吃瓜专题合集
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">九大专题板块，吃瓜不迷路</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 max-w-4xl mx-auto">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#index"
              className="flex items-center gap-4 bg-background-100 hover:bg-background-200 rounded-xl p-4 transition-colors cursor-pointer group no-underline"
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${item.color}`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}